<template>
<div class="m-dialog-congratulation" v-show="visible" ref="dialogRoot">
    <div class="dialog-mask" @click="handleMaskClick"></div>
    <img src="../../assets/v2/congratulation-top.png" alt="" class="congratulation-top">
    <div class="dialog-container">
        <!-- 关闭按钮 -->
        <div class="close-btn" @click="handleClose" v-if="showClose"></div>

        <!-- 标题 -->
        <div class="dialog-title" v-if="title">{{ title }}</div>

        <!-- 内容区域 -->
        <div class="dialog-content" :class="contentClass" ref="dialogContent">
            <slot></slot>
        </div>

        <!-- 底部按钮 -->
        <div class="dialog-footer" v-if="showFooter">
            <slot name="footer">
            <div class="btn primary-btn" @click="handleConfirm">{{ confirmText }}</div>
            </slot>
        </div>
    </div>
</div>
</template>

<script>
import { lock, unlock } from 'tua-body-scroll-lock';
export default {
    name: 'CongratulationDialog',
    props: {
        value: {
          type: Boolean,
          default: false
        },
        title: {
          type: String,
          default: ''
        },
        showClose: {
          type: Boolean,
          default: true
        },
        showFooter: {
          type: Boolean,
          default: true
        },
        confirmText: {
          type: String,
          default: '确定'
        },
        maskClosable: {
          type: Boolean,
          default: true
        },
        appendToBody: {
          type: Boolean,
          default: false
        },
        contentClass: {
          type: [String, Object, Array],
          default: ''
        }
    },
    data() {
      return {
        originalParent: null
      }
    },
    computed: {
        visible: {
          get() {
              return this.value
          },
          set(val) {
              this.$emit('input', val)
          }
        }
    },
    watch: {
        value(val) {
          if (val) {
            this.$nextTick(() => {
              lock(this.$refs.dialogContent);
            });
          } else {
            unlock();
          }
        },
        appendToBody: {
          handler(val) {
            if (this.$refs.dialogRoot) {
              if (val) {
                this.moveToBody();
              } else {
                this.moveBack();
              }
            }
          },
          immediate: true
        }
    },
    mounted() {
        if (this.value) {
          this.$nextTick(() => {
            lock(this.$refs.dialogContent);
          });
        }
        
        if (this.appendToBody) {
          this.moveToBody();
        }
    },
    beforeDestroy() {
      if (this.appendToBody && this.$refs.dialogRoot && this.$refs.dialogRoot.parentNode === document.body) {
        document.body.removeChild(this.$refs.dialogRoot);
      }
      unlock();
    },
    methods: {
        handleClose() {
          this.visible = false
          this.$emit('close')
        },
        handleMaskClick() {
          if (this.maskClosable) {
              this.handleClose()
          }
        },
        handleConfirm() {
          this.$emit('confirm')
        },
        moveToBody() {
          const el = this.$refs.dialogRoot;
          if (el && el.parentNode !== document.body) {
            this.originalParent = el.parentNode;
            document.body.appendChild(el);
          }
        },
        moveBack() {
          const el = this.$refs.dialogRoot;
          if (el && this.originalParent && el.parentNode === document.body) {
            this.originalParent.appendChild(el);
          }
        }
    }
}
</script>

<style lang="less">
.m-dialog-congratulation {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10004;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .congratulation-top {
    margin-bottom: -10px;
    width: 522px;
    z-index: 1;
  }
  .dialog-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
  }

  .dialog-container {
    position: relative;
    width: 494px;
    background: #fff;
    border-radius: 36px;
    padding: 0 36px;
    z-index: 1;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 150px;
      background: url('../../assets/v2/dialog-top-bg.png') no-repeat center;
      background-size: 100% 100%;
      border-radius: 24px 24px 0 0;
      z-index: -1;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 90px;
      background: url('../../assets/v2/dialog-btm-bg.png') no-repeat center;
      background-size: 100% 100%;
      border-radius: 0 0 24px 24px;
      z-index: -1;
    }

    .close-btn {
      position: absolute;
      top: 15px;
      right: 20px;
      width: 100px;
      height: 100px;
      background: url('../../assets/v2/dialog-close.png') no-repeat center;
      background-size: 18px 18px;
      cursor: pointer;
    }

    .dialog-title {
      // font-family: AlimamaFangYuanTiVF-Thin;
      font-weight: 600;
      font-size: 32px;
      color: #FDB03E;
      padding-top: 66px;
      text-align: center;
    }

    .dialog-content {
      padding: 0 16px;
    }

    .dialog-footer {
      .btn {
        margin-bottom: 36px;
        height: 90px;
        line-height: 90px;
        border-radius: 24px 24px 24px 24px;
        font-family: PingFang SC-Semibold;
        font-weight: 600;
        font-size: 36px;
        text-align: center;
        cursor: pointer;
      }

      .primary-btn {
        background: linear-gradient( 45deg, #FFA92A 0%, #FFD18B 100%);
        color: #FFFFFF;
      }
    }
  }
}
</style>